<template lang="">
  <BaseView :title="title" class="mb-5">
    <template #content>
      <b-container fluid>
        <b-row class="mb-3">
          <b-col>
            <listado-proveedores />
          </b-col>
        </b-row>
      </b-container>
    </template>
  </BaseView>
</template>

<script>
import { ListadoProveedores } from '@/components';
import { mapGetters } from 'vuex';
export default {
  name: 'Proveedores',
  components: {
    ListadoProveedores,
  },
  data() {
    return {
      title: 'Proveedores',
      loading: true,
    };
  },
};
</script>

<style lang=""></style>
